export const types = {
  authLogin: "[auth] realizar logeo",
  authLogOut: "[auth]  realizando logout",

  uiOpenModal: "[ui] abriendo modal",
  uiCloseModal: "[ui] cerrando modal",
  uiOpenModalInfo: "[ui] abrir modal de informacion",
  uiCloseModalInfo: "[ui] cerrando modal de informacion",
  uiOpenModalLikes: "[ui] abrir modal de likes",
  uiCloseModalLikes: "[ui] cerrar modal de likes",
  uiOpenModalComents: "[ui] abrir modal de Coments",
  uiCloseModalComents: "[ui] cerrar modal de Coments",
  uiaddComentsToModal: "[ui] agregando comentarios al modal",
  uiOpenModalFriends: "[ui] abrir modal de amigos",
  uiCloseModalFriends: "[ui] cerrar modal de amigos",

  postCreatePost: "[post] creando post",
  postGetAllPosts: "[post] traer todos los post",
  postClearPosts: "[post] limpiando posts",

  profiletSetUser: "[profile] asignando usuario visitado",
  profileSetPosts: "[profile] asignando posts del user visitado",
  profileClearUserVisited: "[profile] limpiando datos de perfil",
  profileSetFriends: "[profile] asignando amigos del perfil visitado",

  usersSetAllUsers: "[users] asignando todos los users",

  friendsAddFriend: "[friends] agregando un amigo",
};
